<template>
  <div class="spnod-admin__form--container container pl-0 mx-0">
    <b-form @submit.stop.prevent="handleSubmit">
      <b-form-row class="mb-2">
        <b-col>
          <b-form-input
            name="firstName"
            v-model="$v.form.firstName.$model"
            :state="validateState('firstName')"
            type="text"
            placeholder="First Name"
            size="sm"
          ></b-form-input>
        </b-col>
        <b-col>
          <b-form-input
            name="lastName"
            v-model="$v.form.lastName.$model"
            :state="validateState('lastName')"
            type="text"
            placeholder="Last Name"
            size="sm"
          ></b-form-input>
        </b-col>
      </b-form-row>
      <b-form-group
        label-cols="3"
        label-cols-md="2"
        label="DOB"
        label-for="dob"
        class="mb-0"
      >
        <b-form-input
          id="dob"
          name="DOB"
          v-model="$v.form.DOB.$model"
          :state="validateState('DOB')"
          type="date"
          size="sm"
          class="mb-2"
          cols="8"
        ></b-form-input>
      </b-form-group>
      <b-form-input
        name="email"
        v-model="$v.form.email.$model"
        :state="validateState('email')"
        type="email"
        placeholder="Email"
        size="sm"
        class="mb-2"
      ></b-form-input>
      <b-form-group class="mb-0">
        <b-form-input
          name="phone"
          v-model="$v.form.phone.$model"
          :state="validateState('phone')"
          type="tel"
          placeholder="Phone Number"
          size="sm"
          class="mb-2"
        ></b-form-input>
        <b-form-invalid-feedback class="mb-2">
          Must follow this format: 8885551234
        </b-form-invalid-feedback>
      </b-form-group>
      <div class="form-check mb-4">
        <input id="checkbox" v-model="isTheirParent" class="form-check-input" type="checkbox">
        <label class="form-check-label" for="checkbox">
          Check here if you are this user's parent or guardian
        </label>
      </div>
      <b-form-group v-if="groups.total > 0">
        <h5 class="spnod-admin__account--header">Add to Group</h5>
        <select
          v-model="group"
          class="form-control mb-4"
          size="sm"
        >
          <option :key="0" :value="null">Assign a group (optional)</option>
          <option v-for="(group, index) in groups.data" :key="index + 1" :value="group._id">
            {{ group.name }}
          </option>
        </select>
      </b-form-group>
      <b-form-group class="d-flex justify-content-end">
        <b-button class="spnod-admin__form--button" size="sm" @click="handleReset">Reset</b-button>
        <b-button class="spnod-admin__form--button" type="submit" size="sm" :disabled="isDisabled">
          <p v-if="!isSending">Submit</p>
          <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, numeric, alpha } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  name: 'UserForm',
  mixin: [validationMixin],
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        DOB: '',
        email: '',
        phone: ''
      },
      group: null,
      isTheirParent: false,
      isSending: false
    }
  },
  computed: {
    ...mapGetters(['newUser', 'isParent', 'groups', 'activeGroup']),
    isDisabled() {
      const anyBlanks = Object.entries(this.form).some((arr) => arr[0] !== 'DOB' && arr[1] === '')
      return anyBlanks || this.$v.form.$anyError
    }
  },
  created: async function () {
    await this.getGroups({})
    if (this.newUser) {
      this.form = this.newUser.data
      this.isTheirParent = this.isParent
    }
    if (this.activeGroup) {
      this.group = this.activeGroup
    }
  },
  methods: {
    ...mapActions(['createNewClient', 'resetNewUser', 'setActiveGroup', 'getGroups']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleSubmit: async function (e) {
      this.$v.form.$touch()

      if (this.$v.form.$anyError) {
        return
      }

      const dobDate = new Date(this.form.DOB.replace(/-/g, '/'))
      let ageDifMs = Date.now() - dobDate.getTime()
      let ageDate = new Date(ageDifMs)
      let age = Math.abs(ageDate.getUTCFullYear() - 1970)

      this.isSending = true
      await this.createNewClient(this._data)
      this.setActiveGroup(this.group)

      if (age < 18) {
        this.$router.push('/user/parents')
      } else {
        this.$router.push('/user/payment')
      }
    },
    handleReset: function () {
      this.resetNewUser()
      this.form = {
        firstName: '',
        lastName: '',
        DOB: '',
        email: '',
        phone: ''
      }
      this.isTheirParent = false
    }
  },
  validations: {
    form: {
      firstName: { required, alpha },
      lastName: { required, alpha },
      DOB: {},
      email: { required, email },
      phone: { required, numeric, isTenDigits: (number) => number.length === 10 }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/UserForm.vue?67120926